import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: '¿Sirve si nunca usé IA antes?',
    a: 'Sí. El Tomo 1 arranca desde cero absoluto. El Bono 1 te tiene configurado y produciendo resultados en 10 minutos. No necesitás conocimientos previos de tecnología.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después del pago recibís un email con el link de descarga. Acceso en menos de 5 minutos. Los PDFs funcionan en cualquier dispositivo: computadora, tablet o celular.'
  }, {
    q: '¿Qué lo diferencia del contenido gratuito de YouTube?',
    a: 'El contenido gratuito de YouTube te da fragmentos desconectados. El MegaPack IA es un sistema integrado donde cada tomo construye sobre el anterior. No buscás información: seguís un camino diseñado para llevarte de principiante a avanzado con resultados medibles.'
  }, {
    q: '¿Tiene garantía real?',
    a: '7 días. Sin condiciones. Si no es lo que esperabas, escribís a soporte y te devolvemos el 100%. Sin formularios de justificación, sin períodos de espera. La tasa de devolución es menor al 1% porque el material entrega lo que promete.'
  }, {
    q: '¿Para qué tipo de persona es este MegaPack?',
    a: 'Para cualquier persona hispanohablante que quiera usar la IA como una herramienta real de trabajo: emprendedores, freelancers, empleados, dueños de negocio, creadores de contenido, estudiantes y profesionales de cualquier industria.'
  }, {
    q: '¿Funciona en todos los países?',
    a: 'Sí. Está escrito en español neutro y los precios están en USD para facilitar el acceso desde cualquier país hispanohablante.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-surface/30" data-id="element-83">
      <div className="max-w-3xl mx-auto" data-id="element-84">
        <div className="text-center mb-12" data-id="element-85">
          <h2 className="text-3xl font-heading font-bold text-white" data-id="element-86">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="space-y-4" data-id="element-87">
          {faqs.map((faq, idx) => <div key={idx} className="bg-surface border border-border rounded-xl overflow-hidden" data-id="element-88">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-89">
                <span className="font-bold text-lg text-white" data-id="element-90">{faq.q}</span>
                <ChevronDown className={`text-brand transition-transform duration-300 ${openIdx === idx ? 'rotate-180' : ''}`} size={24} data-id="element-91" />
              </button>
              <AnimatePresence data-id="element-92">
                {openIdx === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-93">
                    <div className="px-6 pb-6 text-gray-300 border-t border-border/50 pt-4" data-id="element-94">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}